import * as React from "react";

import "./profile-layout.scss";

import {isApiTrue}      from "@Common/logic/is-api-true";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {chain}          from "@Common/utils/fs";

import {AGENT_LEVEL, BRANCH_LEVEL, COMPANY_LEVEL} from "../../../common/logic/user-level";
import {AccountTabsLayout}                        from "../../common/account-tabs-layout/account-tabs-layout";

export const ProfileLayout = ({activeTab, next}) => cs(
    consumeContext("accountMenu"),
    consumeContext("company"),
    consumeContext("userLevels"),
    ({accountMenu, company, userLevels}, next) => AccountTabsLayout({
        activeMenu: "profile",
        activeTab,
        config: chain(
            accountMenu?.["profileMenu"]?.subMenu ?? itemsConfig,
            (items) => items.filter((i) => {
                const itemConfig = itemsConfig.find((ic) => ic.name === i.name);
                return !itemConfig.condition || itemConfig.condition({company, userLevels});
            }),
        ),
        next,
    }),
    () => (
        <div className="profile-layout-7mt">
            {next()}
        </div>
    ),
);
const itemsConfig = [
    {
        linkLabel: "Contact Info",
        name : "contact",
        link: "/account/profile/contact",
    },
    {
        linkLabel: "XD+",
        name : "subscription",
        condition: ({company, userLevels}) => (
            userLevels?.userLevel === AGENT_LEVEL
        ),
        link: "/account/profile/subscription",
    },
    {
        linkLabel: "Security",
        name : "security",
        link: "/account/profile/security",
    },
    {
        linkLabel: "APM",
        name : "apm",
        link: "/account/profile/apm",
    },
    {
        linkLabel: "Manage Headshots",
        name : "headshots",
        link: "/account/profile/headshots",
    },
    {
        linkLabel: "Manage Logos",
        name : "logos",
        condition: ({company, userLevels}) => (
            userLevels?.userLevel === COMPANY_LEVEL ? (
                isApiTrue(company?.prefs?.allowLogoUpload)
            ) : userLevels?.userLevel === BRANCH_LEVEL ? (
                isApiTrue(company?.prefs?.allowLogoUpload)
            ) : userLevels?.userLevel === AGENT_LEVEL ? (
                isApiTrue(company?.prefs?.allowLogoUpload)
            ) : (
                false
            )
        ),
        link: "/account/profile/logos",
    },
    {
        linkLabel: "Social Media",
        name : "social",
        condition: ({company, userLevels}) => (
            userLevels?.userLevel === COMPANY_LEVEL ? (
                isApiTrue(company?.prefs?.allowSocialMediaAccMngtCompany)
            ) : userLevels?.userLevel === BRANCH_LEVEL ? (
                isApiTrue(company?.prefs?.allowSocialMediaAccMngtBranch)
            ) : userLevels?.userLevel === AGENT_LEVEL ? (
                isApiTrue(company?.prefs?.allowSocialMediaAccMngtAgent)
            ) : (
                false
            )
        ),
        link: "/account/profile/social",
    },
];
